const GL = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3csvg%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%20513%20342'%3e%3crect%20fill='%23D80027'%20width='513'%20height='342'/%3e%3cpolygon%20fill='%23FFFFFF'%20points='513,0%20513,171%200,171%200,0%20'/%3e%3ccircle%20fill='%23FFFFFF'%20cx='185.8'%20cy='171.2'%20r='117.8'/%3e%3cpath%20fill='%23D80027'%20d='M68,171c0-65.1,52.8-117.8,117.8-117.8c65.1,0,117.8,52.8,117.8,117.8'/%3e%3c/svg%3e";
export {
  GL as default
};
//# sourceMappingURL=GL.svg.es.js.map
